import { call, put, takeLatest } from 'redux-saga/effects'
import { ReviewsActions, ReviewsTypes } from './reviewsSlice'
import api from '../../services/api'

const getErrorMessage = (response) =>
  response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem

function* createListingReviewSaga(action) {
  const { listingId, payload } = action
  const response = yield call(api.createListingReview, listingId, payload)

  if (response.ok) {
    yield put(ReviewsActions.createListingReviewSuccess(response.data))
  } else {
    yield put(ReviewsActions.createListingReviewFailure({
      problem: response.problem,
      status: response.status,
      message: response.data?.message,
    }))
  }
}

function* fetchListingReviewsSaga(action) {
  const { listingId, options } = action
  const response = yield call(api.getListingReviews, listingId, options)

  if (response.ok) {
    yield put(ReviewsActions.fetchListingReviewsSuccess(response.data))
  } else {
    yield put(ReviewsActions.fetchListingReviewsFailure(getErrorMessage(response)))
  }
}

export default function* reviewsSaga() {
  yield takeLatest(ReviewsTypes.CREATE_LISTING_REVIEW_REQUEST, createListingReviewSaga)
  yield takeLatest(ReviewsTypes.FETCH_LISTING_REVIEWS_REQUEST, fetchListingReviewsSaga)
}